// src/services/auth.js
import apiService from './api';

const authService = {

  login: async (credentials) => {
    // response = { user, access, refresh, message }
    const response = await apiService.auth.login(credentials);
    if (response.access) {
      localStorage.setItem('access_token',  response.access);
      localStorage.setItem('refresh_token', response.refresh);
      localStorage.setItem('user', JSON.stringify(response.user));
    }
    return response;
  },

  register: async (userData) => {
    const response = await apiService.auth.register(userData);
    if (response.access) {
      localStorage.setItem('access_token',  response.access);
      localStorage.setItem('refresh_token', response.refresh);
      localStorage.setItem('user', JSON.stringify(response.user));
    }
    return response;
  },

  logout: async () => {
    const refresh = localStorage.getItem('refresh_token');
    try {
      if (refresh) await apiService.auth.logout(refresh);
    } finally {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
    }
  },

  getProfile: async () => {
    const response = await apiService.auth.getProfile();
    // Always persist the latest profile (including is_premium / premium_plan)
    // so that getCurrentUser() reflects premium state on next boot.
    if (response) {
      localStorage.setItem('user', JSON.stringify(response));
    }
    return response;
  },

  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem('user');
      return userStr ? JSON.parse(userStr) : null;
    } catch {
      return null;
    }
  },

  isAuthenticated: () => !!localStorage.getItem('access_token'),
};

export default authService;